<div id="acc-root" class="acc-overlay" (click)="onClose()">
  <section
    class="acc-card ec-card"
    role="dialog"
    aria-modal="true"
    aria-labelledby="tc-title"
    (click)="$event.stopPropagation()"
  >
    <h2 id="tc-title">{{ 'componentsWizard.templateCreate.title' | translate }}</h2>

    <form class="acc-form ec-form" [formGroup]="form" (ngSubmit)="submit()">
      <!-- Nom -->
      <div class="acc-field">
        <label>{{ 'componentsWizard.templateCreate.nameLabel' | translate }}</label>
        <input class="acc-input ec-input" type="text" formControlName="name" [placeholder]="'componentsWizard.templateCreate.namePlaceholder' | translate" />
      </div>

      <!-- Sujet -->
      <div class="acc-field">
        <label>{{ 'componentsWizard.templateCreate.subjectLabel' | translate }}</label>
        <input class="acc-input ec-input" type="text" formControlName="subject" [placeholder]="'componentsWizard.templateCreate.subjectPlaceholder' | translate" />
      </div>

      <!-- Contenu -->
      <div class="acc-field">
        <label>{{ 'componentsWizard.templateCreate.contentLabel' | translate }}</label>
        <textarea class="acc-input ec-input ec-textarea" rows="6" formControlName="content"
                  [placeholder]="'componentsWizard.templateCreate.contentPlaceholder' | translate"></textarea>
      </div>

      <div *ngIf="errorMsg" class="acc-msg acc-msg--error">{{ errorMsg }}</div>

      <div class="acc-actions ec-actions">
        <button type="button" class="acc-btn acc-cancel" [disabled]="loading" (click)="onClose()">
          {{ 'componentsWizard.templateCreate.cancel' | translate }}
        </button>
        <button class="acc-btn acc-primary" type="submit" [disabled]="loading || form.invalid">
          {{ (loading ? 'componentsWizard.templateCreate.creating' : 'componentsWizard.templateCreate.create') | translate }}
        </button>
      </div>
    </form>
  </section>
</div>